import React, { useState } from "react";
import {
  ModalBuilder,
  Modal,
  Table,
  Lookup,
  PageLoader,
} from "@redriver/cinnamon";
import { PermissionCheck } from "features/../../../shared/components/auth";
import MeteredServiceForm from "./MeteredServiceForm";
import { LookupTypes } from "features/../../../shared/features/Settings";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { getMeteredServiceForEdit } from "./actions";

const EditMeteredServiceModal = ({
  submitAction,
  onSubmitted,
  serviceId,
  dealerOfficeId,
}) => {
  const [uploadDoc, setUploadDoc] = useState(null);

  const onChangeUpload = (file) => {
    let fileReader = new FileReader();
    fileReader.onload = () => {
      const res = fileReader.result;
      setUploadDoc(res);
    };
    fileReader.readAsDataURL(file);
  };
  return (
    <PermissionCheck target={Targets.Service} action={Actions.Edit}>
      <Lookup
        lookup={LookupTypes.ContractTypes}
        render={({ loading, response: contractTypeResponse }) => (
          <ModalBuilder
            withForm
            loadAction={getMeteredServiceForEdit}
            loadParams={{ id: serviceId }}
            submitAction={submitAction}
            submitParams={{ id: serviceId, uploadDoc }}
            onSubmitted={onSubmitted}
            renderTrigger={(showModal) => (
              <Table.MenuItem onClick={showModal}>Edit</Table.MenuItem>
            )}
            renderModal={(modalProps, formProps, state) => (
              <Modal.Edit
                {...modalProps}
                header="Edit Metered Service"
                submitLabel="Update"
              >
                {loading ? (
                  <PageLoader />
                ) : (
                  <MeteredServiceForm
                    loading={state.loading}
                    formProps={formProps}
                    contractTypeResponse={contractTypeResponse}
                    dealerOfficeId={dealerOfficeId}
                    onChangeUpload={onChangeUpload}
                    meteredServiceId={serviceId}
                  />
                )}
              </Modal.Edit>
            )}
          />
        )}
      />
    </PermissionCheck>
  );
};

export default EditMeteredServiceModal;
